import { AbstractAd } from '@lib/iab/iab-vast-model/ad/abstract';

import createInLine from './in-line';
import createWrapper from './wrapper';
import ErrorHandler from '../errors/error-handler';

interface UnmarshalerNode {
    _value: unknown;
    [key: string]: unknown;
}

interface ParseOptions {
    strict: boolean;
    noSingleAdPods: boolean;
    errorHandler: ErrorHandler;
}

const createAd = ($ad: UnmarshalerNode, options: ParseOptions): AbstractAd => {
    if ($ad.inLine != null) {
        return createInLine($ad, options);
    } else if ($ad.wrapper != null) {
        return createWrapper($ad, options);
    } else {
        throw new Error('Unrecognized ad type');
    }
};

export default createAd;
